/* BYLOS — newsletter popup: opens once the shopper scrolls, respects "no thanks" */
(() => {
  const d = document;
  const pop = d.querySelector('[data-pop]');
  if (!pop) return;
  const KEY = 'bylos-pop';
  const read = () => { try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) { return {}; } };
  const write = (v) => { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} };
  const state = pop.dataset.state;
  let lastFocus;

  const open = () => {
    if (pop.classList.contains('is-open')) return;
    lastFocus = d.activeElement;
    pop.classList.add('is-open'); pop.setAttribute('aria-hidden', 'false');
    d.documentElement.classList.add('no-scroll');
    setTimeout(() => (pop.querySelector('.pop__input') || pop.querySelector('.pop__close'))?.focus({ preventScroll: true }), 400);
  };
  const close = () => {
    pop.classList.remove('is-open'); pop.setAttribute('aria-hidden', 'true');
    d.documentElement.classList.remove('no-scroll');
    const s = read();
    if (state !== 'success' && !s.joined) write({ ...s, closed: Date.now() });
    lastFocus?.focus?.({ preventScroll: true });
  };

  pop.querySelectorAll('[data-pop-close]').forEach((b) => b.addEventListener('click', close));
  d.addEventListener('keydown', (e) => { if (e.key === 'Escape' && pop.classList.contains('is-open')) close(); });

  // Copy code
  const copyBtn = pop.querySelector('[data-copy]');
  copyBtn?.addEventListener('click', () => {
    const label = copyBtn.querySelector('[data-copy-label]');
    const done = () => { if (label) { label.textContent = 'Copied'; setTimeout(() => { label.textContent = 'Tap to copy'; }, 1800); } };
    if (navigator.clipboard) navigator.clipboard.writeText(copyBtn.dataset.copy).then(done, done); else done();
  });

  // Just signed up, or the form came back with an error: show it right away
  if (state === 'success') { write({ ...read(), joined: true }); open(); return; }
  if (state === 'error') { open(); return; }

  const saved = read();
  const WEEK = 7 * 24 * 60 * 60 * 1000;
  if (saved.joined || (saved.closed && Date.now() - saved.closed < WEEK)) return;

  const depth = (parseInt(pop.dataset.scroll, 10) || 35) / 100;
  const started = Date.now();
  const onScroll = () => {
    const max = d.documentElement.scrollHeight - innerHeight;
    if (max <= 0) return;
    if (window.scrollY / max >= depth && Date.now() - started > 3000) {
      window.removeEventListener('scroll', onScroll);
      if (!d.querySelector('[data-cart-drawer].is-open')) open();
      else setTimeout(onScroll, 4000);
    }
  };
  window.addEventListener('scroll', onScroll, { passive: true });
})();
